<template>
    <component
        :is="display"
        :quote="quote"
        :data="data"
        :columns="columns"
        :rows="rows"
        :cards="cards"
    />
</template>

<script setup>
import {computed, inject, markRaw, onMounted, ref} from "vue";
import { useUser } from "@/Composables";
import SourcingQuoteDialog from "../../../Themes/Sourcing/Components/Modules/Dialogs/QuoteDialog.vue";
import MarketingQuoteDialog from "../../../Themes/Marketing/Components/Modules/Dialogs/QuoteDialog.vue";
import axios from "axios";
import {MoneyFormat, PreviewLinkFormat} from "@/Components";
import QuoteLineDetail from "../Formatters/QuoteLineDetail.vue";

const route = inject("route");
const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode ? SourcingQuoteDialog : MarketingQuoteDialog
);

const props = defineProps(["data"]);
const isLoading = ref(true);
const quote = ref();
const cards = ref({});

onMounted(() => {
    axios
        .get(route("api.v1.public.account.quotes.show", props.data),{
            params: {
                with: ["quote", "cards", "salesData"],
            }
        })
        .then((response) => {
            quote.value = response.data["quote"];
            cards.value = response.data["cards"] || {};
            isLoading.value = false;
        });
});

const columns = [
    {
        name: "Item #",
        sortPath: "item_id",
        component: markRaw(QuoteLineDetail),
        props: row => ({
            linkText: row.item_id,
            routeName: 'web.catalog.products.show',
            routeParams: row.slug,
            linkDescription: cards.value?.[row.item_id]?.display_short_description ?? (row.concat_description ?? ''),
            line: row,
            quote: quote.value,
            card: cards.value?.[row.item_id],
            showManufacturer: true,
        }),
        noWrap: false
    },
    {
        name: "Qty",
        path: "quantity_ordered",
    },
    {
        name: "Price",
        path: "price",
        component: markRaw(MoneyFormat),
        alignRight: true,
        props: (row) => {
            return {
                amount: row.price,
                alignRight: true,
            };
        },
    },
    {
        name: "Ext.",
        path: "subtotal",
        component: markRaw(MoneyFormat),
        alignRight: true,
        cellClass: 'font-medium',
        props: (row) => {
            return {
                amount: row.subtotal,
                alignRight: true,
            };
        },
    },
];

const rows = computed(() => quote.value?.lines);
</script>
